import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import InlineSVG from 'svg-inline-react';

import classes from './LoginWithToken.scss';
import Logo from '../../../assets/logo_login.svg';
import { simplApi } from '../../../api/simplApi';
import { Link } from 'react-router';

class LoginWithToken extends React.Component {
  constructor(props) {
    super(props);

    if (props.params.token.length) {
      localStorage.setItem('token', props.params.token);
      window.location.href = '/';
    }
  }

  render() {
    return (
      <div className={classes.wrapper}>
        <div className={classes.invitation}>
          <div className={classes.logoWrapper}>
            <InlineSVG src={Logo} className={classes.logo} />
          </div>
          <h1>Willkommen bei SiMPL</h1>

          <p>Starte Loginverfahren.</p>
        </div>
      </div>
    );
  }
}
LoginWithToken.propTypes = {
  params: PropTypes.object.isRequired,
};
export default LoginWithToken;



// WEBPACK FOOTER //
// ./src/routes/LoginWithToken/components/LoginWithToken.js